import React, { useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'
import { useDispatch } from 'react-redux';
import { showLoader } from '../../Redux/Slices/loaderSlice';
import { getPrivacyPolicyAndTermsAndCondition_public } from '../../Redux/Actions/action';

const PrivacyPolicy = () => {
  const dispatch = useDispatch();
  const [privacyPolicyData, setPrivacyPolicyData] = useState("")

  const _getPrivacyPolicyAndTermsAndCondition = async () => {
    dispatch(showLoader(true));
    try {
      const body = {
        type: "Privacy-Policy"
      }
      const res = await dispatch(getPrivacyPolicyAndTermsAndCondition_public(body));
      setPrivacyPolicyData(res.payload?.data?.data?.description);
      dispatch(showLoader(false));
    } catch (err) {
      console.error('Error:', err);
      dispatch(showLoader(false));
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    _getPrivacyPolicyAndTermsAndCondition()
  }, []);

  return (
    <>
      <Box sx={{
        background: "rgba(3, 119, 124, 0.2)",
        borderRadius: '12px',
        padding: '20px',
        margin: { lg: '40px', md: "30px", sm: '20px', xs: '10px' }
      }}>
        <Typography
          color={"primary"}
          sx={{
            fontSize: { lg: "32px", md: "26px", sm: "22px", xs: "20px" },
            fontWeight: "900",
            mb: 3
          }}
        >
          Privacy Policy
        </Typography>
        <div dangerouslySetInnerHTML={{ __html: privacyPolicyData }} />
      </Box>
    </>
  )
}

export default PrivacyPolicy
